import React from 'react'
import styles from './loading.module.scss'
import BaseLoading from '@/src/components/helpers/base-loading/base-loading'
import CreateElements from '@/src/components/helpers/create-elements/create-elements'

export default function LoadingPromotions() {
    return (
        <BaseLoading>
            <section className={styles.container}>
                <aside className={styles.promotionsTitle} />
                <div className={styles.cards}>
                    <CreateElements quantity={5}>
                        <div className={styles.card}>
                            <aside className={styles.image} />
                            <div className={styles.descriptionArea}>
                                <aside className={styles.discount} />
                                <aside className={styles.productName} />
                                <aside className={styles.description} />
                                <aside className={styles.price} />
                            </div>
                        </div>
                    </CreateElements>
                </div>
            </section>
        </BaseLoading>
    )
}
